import {formatString} from '@optimaxdev/utils';

export const GENERAL_EXPERIMENT_INDICATION = {
    action: formatString('{{expName}}'),
    category: 'EXP Indication',
    label: formatString('{{label}}'),
    name: 'General',
};

export const GENERAL_NEW_TAB = {
    action: 'Browser Tab',
    category: 'General',
    label: 'New Tab - Opened',
    name: 'General',
};

export const GENERAL_RETURN_TAB = {
    action: 'Browser Tab',
    category: 'General',
    label: 'Returned To Tab - GUSA',
    name: 'General',
};

export const GENERAL_NEWSLETTER_INDICATION = {
    action: 'User Subscribed',
    category: 'Newsletter Registration',
    label: formatString('{{label}}'),
    name: 'General',
};

export const GENERAL_HEADER_BUTTON = {
    action: formatString('{{buttonName}}'),
    category: formatString('Header - {{version}}'),
    label: formatString('{{label}}'),
    name: 'General',
};
